module.exports = __webpack_public_path__ + "img/car_10.476afa70.jpg";